import { useTranslation } from 'react-i18next';
import { Button, Flex, Image } from 'antd';
import { useMachineDetailsRobotSchedule } from '../../../../context/MachineDetailsRobotScheduleContext';
import type { SelectedScheduleRouteRoutine } from '../../../../types/MachineDetailsRobotSchedule.types';
import { parseIso8601DurationMinutes } from '../../../../utils/schedule';
import {
  CleaningScheduleCardContainer,
  CleaningScheduleCardContent,
  CleaningScheduleCardDescription,
  CleaningScheduleCardTitle,
} from './CleaningScheduleCard.styles';
import { kccThemeConstants } from 'config/theme/kccTheme/kccTheme';
import { SvgIcon } from 'lib/components/SvgIcon/SvgIcon';
import routeRoutinePlaceholder from 'lib/assets/images/Routine_Example.png';

interface CleaningScheduleCardB50Props {
  selectedRouteRoutine: SelectedScheduleRouteRoutine;
  onEdit: () => void;
}

export const CleaningScheduleCardB50 = ({
  selectedRouteRoutine,
  onEdit,
}: CleaningScheduleCardB50Props): JSX.Element => {
  const { t } = useTranslation();
  const { isReadOnly } = useMachineDetailsRobotSchedule();

  const isRoutine = selectedRouteRoutine.type === 'routine';
  const selectedInstance = isRoutine ? selectedRouteRoutine.routine : selectedRouteRoutine.route;

  return (
    <CleaningScheduleCardContainer>
      <Flex align="center" gap={kccThemeConstants.SPACING.SM}>
        <Image width={48} height={48} src={routeRoutinePlaceholder} alt="Route Routine" preview={false} />

        <CleaningScheduleCardContent vertical gap={2}>
          <Flex align="center" justify="space-between">
            <CleaningScheduleCardTitle>{selectedInstance.name}</CleaningScheduleCardTitle>

            {!isReadOnly && (
              <Button
                type="link"
                aria-label={t('common.edit')}
                icon={<SvgIcon name="editNew" />}
                onClick={onEdit}
                style={{ width: kccThemeConstants.SIZE.S250, height: kccThemeConstants.SIZE.S250 }}
              />
            )}
          </Flex>

          <CleaningScheduleCardDescription>
            {t('createSchedule.durationInMinutes', {
              duration: parseIso8601DurationMinutes(selectedInstance.duration),
            })}
          </CleaningScheduleCardDescription>
        </CleaningScheduleCardContent>
      </Flex>
    </CleaningScheduleCardContainer>
  );
};
